import axios from "axios";
import { CORREO_USUARIO } from "config/general/Configuracion";
import { API_USUARIO } from "config/general/Configuracion";
import { API_PLACAS } from "config/general/Configuracion";
import { NUMERODOCUMENTOUSUARIO } from "config/general/Configuracion";
import { NOMBREAPELLIDOUSUARIO } from "config/general/Configuracion";
import { FOTOPERFILUSUARIO } from "config/general/Configuracion";
import { ID_CUENTA } from "config/general/Configuracion";
import { HEADERS, apiTimeout } from "config/general/Configuracion";


const IngresoSistemaApiHelper = {

    obtenerInformacionUsuario: async () => {
        try {
            const url = `${API_USUARIO}/v1/usuario/ciudad/me/${localStorage[ID_CUENTA]}/${localStorage[CORREO_USUARIO]}`;
            const response = await axios.get(url, {
                headers: HEADERS(),
                timeout: apiTimeout
            });
            localStorage[FOTOPERFILUSUARIO] = response.data.fotoPerfil;
            localStorage[NOMBREAPELLIDOUSUARIO] = response.data.nombre1 + ' ' + response.data.apellido1;
            localStorage[NUMERODOCUMENTOUSUARIO] = response.data.identificacion;
            return response.data;
        } catch (error) {
            console.error("Error al obtener ID de usuario:", error);
            throw error;
        }
    },
    obtenerPlacasUsuario: async () => {
        try {
            const url = `${API_PLACAS}/v1/placas/ciudad/me/${localStorage[ID_CUENTA]}/${localStorage[NUMERODOCUMENTOUSUARIO]}`;
            const response = await axios.get(url, {
                headers: HEADERS(),
                timeout: apiTimeout
            });
            return response.data;
        } catch (error) {
            console.error("Error al obtener placas de usuario:", error);
            throw error;
        }
    },

};

export default IngresoSistemaApiHelper;
